import styled from "styled-components";
import { useState, useEffect } from "react";
import FormStringInput from "../../../components/FormControls/FormStringInput";
import FormPasswordInput from "../../../components/FormControls/FormPasswordInput";
import PrimaryButton from "../../../components/FormControls/PrimaryButton";
import FormSelectWithLabel from "../../../components/FormControls/FormSelectWithLabel";
import request from "../../../api/request";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { useNavigate } from 'react-router-dom';

const StyledLoginPage = styled.div`
    display: flex;
    align-items: center;
    background-color: ${(props) => props.theme.color.lightgray};
    height: calc(100vh - 60px);
    font-family: Segoe UI;
`;

const WhiteBoard = styled.div`
    display: flex;
    background-color: white;
    box-sizing: border-box;
    margin: auto;
    color: ${(props) => props.theme.color.gray};
    background-color: #fff;
  border-radius: .3rem;
  box-shadow: 0 .75rem 1.5rem rgba(0,0,0,.01),0 .25rem .25rem rgba(0,0,0,.1);
  overflow: hidden;
  padding: 25px;
  position: relative;
  font-family: Inter;
  min-width: 23rem;
  max-width: 23rem;
  text-align: left;
  display: block;



`;

const Title = styled.span`
display:block;
font-size: 28px;
  line-height: 36px;
  font-weight: 800;
  margin: 0;
  color: ${(props) => props.theme.color.dark};
`;

const SubTitle = styled.span`
    font-size: 16px;
  line-height: 30px;
  margin: 0;
  font-weight: 500;
  color: ${(props) => props.theme.color.dark};
`;

const ErrorMessage = styled.span`
    color: ${(props) => props.theme.color.dark};
    font-size: 24px;
    font-weight: 600;
    margin: auto;
`;

const LoginFailedMessage = styled.div`
    color: #dc3545;
    font-size: 12px;
    font-weight: 600;
    text-align: center;
    padding-top: 5px;
    margin-bottom: 20px;
    height: 20px;
`;

function LoginPage(props) {

    const navigate = useNavigate();

    const {setLogin, setDatabaseName, setSettings} = props;

    const SERVER_STATUS_CONNECTING = 0;
    const SERVER_STATUS_CONNECTED = 1;
    const SERVER_STATUS_NODATABASE = 2;
    const SERVER_STATUS_CONNECTION_FAILED = 3;
    const SERVER_STATUS_LOGIN_FAILED = 4;
    const SERVER_STATUS_EMAIL_VERIFICATION_REQUIRED = 5;
    const SERVER_STATUS_EMAIL_VERIFICATION_FAILED = 6;

    let loadedPage = false;

    const [serverStatus, setServerStatus] = useState(SERVER_STATUS_CONNECTING);
    const [dbList, setDbList] = useState([]);
    const [dbName, setDbName] = useState('');
    const [username, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [needsValidation, setNeedsValidation] = useState(false);
    const [dbnameValidated, setDbnameValidated] = useState(undefined);
    const [usernameValidated, setUsernameValidated] = useState(undefined);
    const [passwordValidated, setPasswordValidated] = useState(undefined);
    const [emailVerificationCode, setEmailVerificationCode] = useState('');
    const [emailVerficiationCodeValidated, setEmailVerficiationCodeValidated] = useState(undefined);

    const onDbChange = (e) => {
        setDbName(e.target.value);
        if (needsValidation) {
            setDbnameValidated(e.target.value !== '');
        }
    }

    const onChangeUsername = (txt) => {
        setUserName(txt);
        if (needsValidation) {
            setUsernameValidated(txt !== '');
        }
    }

    const onChangePassword = (txt) => {
        setPassword(txt);
        if (needsValidation) {
            setPasswordValidated(txt !== '');
        }
    }

    const onChangeEmailVerificationCode = (txt) => {
        setEmailVerificationCode(txt);
        if (needsValidation) {
            setEmailVerficiationCodeValidated(txt !== '');
        }
    }

    const onLogin = async () => {
        if (serverStatus !== SERVER_STATUS_EMAIL_VERIFICATION_REQUIRED) {
            if (username === '' || password === '' || dbName === '') {
                setNeedsValidation(true);
                setDbnameValidated(dbName !== '');
                setUsernameValidated(username !== '');
                setPasswordValidated(password !== '');
            } else {
                let loginResp = (await request('auth', 'login', [dbName, username, password]));
                if (loginResp.status === 200) {
                    const user = loginResp.data;

                    if (user.IsTFA === true) {
                        setServerStatus(SERVER_STATUS_EMAIL_VERIFICATION_REQUIRED);
                    } else {
                        setLogin(loginResp.data);
                        setDatabaseName(dbName);

                        let settingResp = (await request('database', 'fetchSettings')).data;
                        setSettings(settingResp);
                        navigate('/homepage');
                    }
                } else {
                    setServerStatus(SERVER_STATUS_LOGIN_FAILED);
                }
            }
        } else {
            if (emailVerificationCode === '') {
                setNeedsValidation(true);
                setEmailVerficiationCodeValidated(emailVerificationCode !== '');
            } else {
                let loginResp = (await request('auth', 'verifyEmail', [dbName, username, emailVerificationCode]));
                if (loginResp.status === 200) {
                    setLogin(loginResp.data);
                    setDatabaseName(dbName);

                    let settingResp = (await request('database', 'fetchSettings')).data;
                    setSettings(settingResp);
                    navigate('/homepage');
                } else {
                    setServerStatus(SERVER_STATUS_EMAIL_VERIFICATION_FAILED);
                }
            }
        }
    };

    useEffect(() => {
        if (!loadedPage) {
            loadedPage = true;
            async function preLoad() {
                try {
                    let dbs = [];

                    let resp = (await request('database', 'fetchDbList')).data;
                    resp.recordset.map((db) => {
                        //if (db.name === "CartrefiBranch") {
                        dbs.push(db.name);

                        if (dbName === '') {
                            setDbName(db.name);
                      //}
                    }
                    });
                    
                    setDbList(dbs);

                    if (resp.recordset.length) {
                        setServerStatus(SERVER_STATUS_CONNECTED);
                    } else {
                        setServerStatus(SERVER_STATUS_NODATABASE);
                    }
                } catch (e) {
                    setServerStatus(SERVER_STATUS_CONNECTION_FAILED);
                }
            }

            preLoad();
        }
    }, []);

    return (
        <StyledLoginPage>
            {serverStatus === SERVER_STATUS_CONNECTING && <LoadingSpinner></LoadingSpinner>}
            {serverStatus === SERVER_STATUS_NODATABASE && <ErrorMessage>No database on server</ErrorMessage>}
            {serverStatus === SERVER_STATUS_CONNECTION_FAILED && <ErrorMessage>Can not connect to server or database</ErrorMessage>}
            {(serverStatus === SERVER_STATUS_CONNECTED || serverStatus === SERVER_STATUS_LOGIN_FAILED) && <WhiteBoard>
                <div style={{margin: 'auto'}}>
                    <Title>Login to</Title>
                    <SubTitle>CAMRA Online COBAS Admin</SubTitle>
                    <FormSelectWithLabel label='Database' items={dbList} value={dbName} onChange={onDbChange} validated={dbnameValidated} style={{width: '100%', height: 35, paddingLeft: 10}}></FormSelectWithLabel>
                    <div style={{paddingTop: 5}}>
                        <FormStringInput label='Username' value={username} onChange={onChangeUsername} validated={usernameValidated} onPressEnter={onLogin} inputStyle={{width:'100%'}}></FormStringInput>
                    </div>
                    <FormPasswordInput label='Password' value={password} onChange={onChangePassword} validated={passwordValidated} onPressEnter={onLogin} inputStyle={{width:'100%'}}></FormPasswordInput>
                    <LoginFailedMessage>{serverStatus === SERVER_STATUS_LOGIN_FAILED ? '* Username or password is incorrect!' : ''}</LoginFailedMessage>
                    <PrimaryButton caption='Login' onClick={onLogin} style={{width: '100%'}}></PrimaryButton>
                </div>
            </WhiteBoard>}
            {(serverStatus === SERVER_STATUS_EMAIL_VERIFICATION_REQUIRED || serverStatus === SERVER_STATUS_EMAIL_VERIFICATION_FAILED) && <WhiteBoard>
                <div style={{margin: 'auto'}}>
                    <Title>Login to system</Title>
                    <div style={{paddingTop: 5, paddingBottom: 10}}>
                    An email was sent automatically by CAMRA Branch Accounting to verify your identity.
                        <FormStringInput label='Enter the code below' value={emailVerificationCode} onChange={onChangeEmailVerificationCode} validated={emailVerficiationCodeValidated} onPressEnter={onLogin} inputStyle={{width:290}}></FormStringInput>
                    </div>
                    <LoginFailedMessage>{serverStatus === SERVER_STATUS_EMAIL_VERIFICATION_FAILED ? '* Verification code is not correct. Please try again.' : ''}</LoginFailedMessage>
                    <PrimaryButton caption='Verify' onClick={onLogin} style={{width: '100%'}}></PrimaryButton>
                </div>
            </WhiteBoard>}
        </StyledLoginPage>
    )
}

export default LoginPage;